import type { ProbeResult as Result } from "@micropod/domain";
import { Icon } from "../ui/Icon";

/**
 * The component the whole wizard exists for.
 *
 * A probe reports what it PROVED, so this renders a claim about reality and the facts
 * behind it — not a green tick and the word "Saved", which tells the tenant nothing about
 * whether their setup actually works.
 *
 * A failure gets the same weight: what is wrong, then the exact next action. Meta's own
 * code sits underneath in small type, for when they have to contact support.
 */
export function ProbeResult({ result }: { result: Result }) {
  if (result.ok) {
    return (
      <div className="probe probe-ok" role="status">
        <div className="probe-head">
          <span className="probe-icon">
            <Icon name="check" size={12} />
          </span>
          <p className="probe-claim">{result.proved}</p>
        </div>
        {Object.keys(result.facts).length > 0 && (
          <dl className="facts">
            {Object.entries(result.facts).map(([k, v]) => (
              <div className="fact" key={k}>
                <dt>{k}</dt>
                <dd>{v}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    );
  }

  return (
    <div className="probe probe-bad" role="alert">
      <div className="probe-head">
        <span className="probe-icon">
          <Icon name="alert" size={12} />
        </span>
        <p className="probe-claim">{result.problem}</p>
      </div>
      <p className="probe-fix">{result.fix}</p>
      {result.providerCode !== null && (
        <p className="probe-code">Meta error {result.providerCode}</p>
      )}
    </div>
  );
}
